/* Pouchman storefront behaviour.
   Shell (mega menu, drawer, age gate, FAQ, the 3D head) plus the per-template
   pieces. Everything degrades: the markup is server rendered, this only adds
   state. Cart writes go through Shopify's own /cart endpoints. */
(function () {
  'use strict';
  var D = document;
  var $ = function (s, r) { return (r || D).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); };
  /* Matches the store's Liquid money format ("Rs. 1,099.00") so a price never
     changes voice between a JS-rendered widget and a server-rendered page.
     Verified split: the pair said ₹2,298 while the cart said Rs. 2,298.00. */
  var money = function (cents) {
    return 'Rs. ' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  var PM = window.PM = { money: money };

  /* ---- cart badge -------------------------------------------------------- */
  function paintCart(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; });
  }
  PM.refreshCart = function () {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { paintCart(c.item_count); return c; })
      .catch(function () { return null; });
  };
  PM.addToCart = function (id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    }).then(function (r) { return r.json(); })
      .then(function (res) {
        PM.refreshCart();
        /* on the cart page an add (People also bought) re-renders the cart in its queue */
        if (PM.cartWrite) PM.cartWrite(function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); });
        return res;
      });
  };
  PM.changeLine = function (key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  };

  /* ---- mega menu --------------------------------------------------------- */
  var tabs = $$('.nav__item[data-mega]');
  function closeMega() {
    $$('.mega').forEach(function (m) { m.hidden = true; });
    tabs.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
  }
  tabs.forEach(function (t) {
    t.addEventListener('click', function () {
      var panel = D.getElementById(t.getAttribute('aria-controls'));
      var open = t.getAttribute('aria-expanded') === 'true';
      closeMega();
      if (!open && panel) {
        panel.hidden = false;
        t.setAttribute('aria-expanded', 'true');
      }
    });
  });
  D.addEventListener('click', function (e) {
    if (e.target.closest('[data-mega-close]')) return closeMega();
    if (!e.target.closest('.mega') && !e.target.closest('.nav__item[data-mega]')) closeMega();
  });
  D.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeMega(); closeDrawer(); } });

  /* ---- mobile drawer ----------------------------------------------------- */
  var drawer = $('#drawer'), burger = $('#burger'), lastFocus = null;
  /* The drawer sits inside the header section, whose stacking context let the
     offers ticker (a later sibling with an animated, composited lane) paint
     over it on phones. Lifted to <body> so its z-index is measured against the
     whole page. */
  if (drawer && drawer.parentNode !== document.body) document.body.appendChild(drawer);
  function openDrawer() {
    if (!drawer) return;
    lastFocus = D.activeElement;
    drawer.classList.add('is-open');
    if (burger) burger.setAttribute('aria-expanded', 'true');
    D.body.style.overflow = 'hidden';
    var x = $('#drawerX'); if (x) x.focus();
  }
  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    D.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  if (burger) burger.addEventListener('click', openDrawer);
  D.addEventListener('click', function (e) {
    if (e.target.closest('#drawerX')) return closeDrawer();
    /* a same-page anchor (Brands / Flavours / Strength on the homepage) closes the drawer so the jump is visible */
    var jump = e.target.closest('a[href*="#"]');
    if (jump && jump.pathname === location.pathname) closeDrawer();
    var t = e.target.closest('[data-acc]');
    if (t) {
      var open = t.getAttribute('aria-expanded') === 'true';
      t.setAttribute('aria-expanded', String(!open));
      t.lastElementChild.textContent = open ? '+' : '−';
      var panel = D.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = open;
    }
  });
  D.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !drawer || !drawer.classList.contains('is-open')) return;
    var f = $$('a[href],button:not([disabled]),input,select', drawer)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && D.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && D.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---- age gate ---------------------------------------------------------- */
  var gate = $('#gate'), GKEY = 'pm_age_ok';
  if (gate) {
    var ok = false;
    try { ok = localStorage.getItem(GKEY) === '1'; } catch (e) {}
    if (!ok) {
      gate.hidden = false;
      D.body.style.overflow = 'hidden';
      var yes = $('#gateYes');
      if (yes) {
        yes.focus();
        yes.addEventListener('click', function () {
          try { localStorage.setItem(GKEY, '1'); } catch (e) {}
          gate.hidden = true;
          D.body.style.overflow = '';
        });
      }
      gate.addEventListener('keydown', function (e) {
        if (e.key === 'Tab' && yes) { e.preventDefault(); yes.focus(); }
      });
    }
  }

  /* ---- FAQ accordion, one open at a time --------------------------------- */
  D.addEventListener('click', function (e) {
    var q = e.target.closest('.faq__q');
    if (!q) return;
    var open = q.getAttribute('aria-expanded') === 'true';
    var scope = q.closest('section') || D;
    $$('.faq__q', scope).forEach(function (o) {
      o.setAttribute('aria-expanded', 'false');
      o.lastElementChild.textContent = '+';
      var p = D.getElementById(o.getAttribute('aria-controls'));
      if (p) p.hidden = true;
    });
    if (!open) {
      q.setAttribute('aria-expanded', 'true');
      q.lastElementChild.textContent = '−';
      var p2 = D.getElementById(q.getAttribute('aria-controls'));
      if (p2) p2.hidden = false;
    }
  });

  /* ---- the 3D head ------------------------------------------------------- */
  PM.buildHead = function (el) {
    var N = 72, bands = ['pm-lid', 'pm-band', 'pm-base'], html = '';
    for (var i = 0; i < N; i++) {
      for (var b = 0; b < 3; b++) html += '<b class="' + bands[b] + '" style="--i:' + i + '"></b>';
    }
    var cyl = el.querySelector('.pm-cyl');
    if (cyl && !cyl.children.length) cyl.innerHTML = html;
  };
  $$('.pm-head').forEach(PM.buildHead);

  /* pointer tilt on the hero head. Not an animation loop: the motion budget
     allows two and the ticker and badge already use both. */
  var head = $('#pmHead'), slot = $('#heroHead');
  if (head && slot && matchMedia('(pointer:fine)').matches &&
      !matchMedia('(prefers-reduced-motion:reduce)').matches) {
    var base = parseFloat(head.style.getPropertyValue('--yaw')) || -23.7, raf = 0, ty = base, tp = 0;
    var apply = function () {
      raf = 0;
      head.style.setProperty('--yaw', ty.toFixed(1) + 'deg');
      head.style.setProperty('--pitch', tp.toFixed(1) + 'deg');
    };
    addEventListener('pointermove', function (e) {
      var r = slot.getBoundingClientRect();
      if (r.bottom < 0 || r.top > innerHeight) return;
      var dx = Math.max(-1, Math.min(1, (e.clientX - (r.left + r.width / 2)) / (innerWidth / 2)));
      var dy = Math.max(-1, Math.min(1, (e.clientY - (r.top + r.height / 2)) / (innerHeight / 2)));
      ty = base + dx * 15; tp = -dy * 9;
      if (!raf) raf = requestAnimationFrame(apply);
    }, { passive: true });
  }

  /* ---- quiz -------------------------------------------------------------- */
  /* Three answers set a target strength and a flavour family; the pick is a real
     can that is in stock right now (live /collections/in-stock/products.json),
     closest in mg to the target, preferring the chosen flavour family. Someone
     who does not use nicotine is told not to start, and gets no product. */
  var qMg = $('#qMg');
  if (qMg) {
    var a = [null, null, null];
    var tierOf = function (mg) { return mg <= 6 ? 'Light' : mg <= 12 ? 'Medium' : mg <= 20 ? 'Strong' : 'Extra strong'; };
    var FAMS = [
      { label: 'Mint', test: function (t) { return t.indexOf('flavour-group:Mint & Cool') > -1; } },
      { label: 'Fruit', test: function (t) { return t.indexOf('flavour-group:Fruit') > -1; } },
      { label: 'Berry', test: function (t) { return t.indexOf('flavour-group:Berries') > -1; } },
      { label: 'Coffee', test: function (t) { return t.some(function (x) { return /coffee|espress/i.test(x); }); } }
    ];
    var cans = null;
    var money = function (p) { return '₹' + Number(p).toLocaleString('en-IN', { maximumFractionDigits: 0 }); };
    var mgOf = function (p) {
      for (var i = 0; i < p.tags.length; i++) { var m = String(p.tags[i]).match(/^(\d+(?:\.\d+)?)\s?mg$/i); if (m) return +m[1]; }
      var t = p.title.match(/(\d+(?:\.\d+)?)\s?mg/i); return t ? +t[1] : null;
    };
    fetch('/collections/in-stock/products.json?limit=250', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        cans = (j.products || []).filter(function (p) {
          var t = p.product_type || '';
          return t !== 'Bundle' && t !== 'Merch' && t !== 'Mystery' &&
            (p.variants || []).some(function (v) { return v.available; }) && mgOf(p) !== null;
        }).map(function (p) {
          var v = p.variants.filter(function (x) { return x.available; })[0];
          return { title: p.title, handle: p.handle, mg: mgOf(p), tags: p.tags || [], price: v.price };
        });
        recompute();
      })
      .catch(function () { cans = []; recompute(); });
    function target() {
      var use = a[0], often = a[1] === null ? 0 : a[1];
      if (use === 0) return [6, 10, 3][often];        /* cigarettes: a few times / most of the day / weekends */
      if (use === 1) return [10, 15, 6][often];       /* pouches already */
      return often === 1 ? 10 : often === 2 ? 3 : 6;  /* not answered yet */
    }
    function pick(mg, fam) {
      var pool = cans || [];
      var byFam = fam ? pool.filter(function (c) { return fam.test(c.tags); }) : [];
      var from = byFam.length ? byFam : pool;
      var best = null;
      from.forEach(function (c) {
        var d = Math.abs(c.mg - mg);
        if (!best || d < best.d || (d === best.d && c.mg < best.c.mg)) best = { c: c, d: d };
      });
      return best ? { can: best.c, famMatch: !!byFam.length } : null;
    }
    function rows(list) {
      $('#qRows').innerHTML = list.map(function (r) {
        return '<div style="display:flex;justify-content:space-between;gap:14px;font-size:13.5px;padding:5px 0">' +
          '<span style="opacity:.65">' + r[0] + '</span><span style="font-weight:600">' + r[1] + '</span></div>';
      }).join('');
    }
    function recompute() {
      var answered = a.filter(function (x) { return x !== null; }).length;
      var cta = $('#qCta');
      $('#qProgress').textContent = answered === 0 ? 'Answer the three, or start from the middle of Light' : answered + ' of 3 answered';
      if (a[0] === 2) {
        qMg.textContent = 'Don’t start';
        $('#qName').textContent = 'Pouches are for adults who already use nicotine';
        $('#qWhy').textContent = 'If you don’t use nicotine today, there is no reason to start. Nicotine is addictive.';
        rows([]); cta.textContent = 'Read the guides'; cta.href = '/pages/guides';
        return;
      }
      var mg = target(), fam = a[2] === null ? null : FAMS[a[2]];
      var why = a[0] === 0 ? 'Coming from cigarettes, start here and move a step up or down after a few days.'
        : a[0] === 1 ? 'You already use pouches, so this sits near what you are used to. Step down if it feels like too much.'
        : 'A middle-of-the-shelf start. Answer the three for a closer match.';
      if (cans === null) {
        qMg.textContent = mg + ' mg'; $('#qName').textContent = 'Finding a can in stock…'; $('#qWhy').textContent = why;
        rows([['Tier', tierOf(mg)], ['Flavour', fam ? fam.label : 'Any']]); cta.textContent = 'See ' + tierOf(mg) + ' cans';
        cta.href = '/collections/all/' + tierOf(mg).toLowerCase().replace(' ', '-');
        return;
      }
      var r = pick(mg, fam);
      if (!r) {
        qMg.textContent = mg + ' mg'; $('#qName').textContent = 'Nothing in stock right now';
        $('#qWhy').textContent = 'Every can is between batches. Leave your email on a can page and we’ll tell you when it lands.';
        rows([['Tier', tierOf(mg)]]); cta.textContent = 'See all cans'; cta.href = '/collections/cans';
        return;
      }
      var c = r.can, close = c.mg !== mg;
      qMg.textContent = c.mg + ' mg';
      $('#qName').textContent = c.title;
      $('#qWhy').textContent = why + (fam && !r.famMatch ? ' No ' + fam.label.toLowerCase() + ' can is in stock right now, so this is the closest strength.' : close ? ' Closest strength in stock to ' + mg + ' mg.' : '');
      rows([['Tier', tierOf(c.mg)], ['Flavour', fam && r.famMatch ? fam.label : 'Closest in stock'], ['Price', money(c.price)], ['Stock', 'In stock']]);
      cta.textContent = 'See ' + c.title; cta.href = '/products/' + c.handle;
    }
    D.addEventListener('click', function (e) {
      var b = e.target.closest('.quiz__o');
      if (b) {
        var qi = +b.dataset.q, oi = +b.dataset.o;
        a[qi] = a[qi] === oi ? null : oi;
        $$('.quiz__o[data-q="' + qi + '"]').forEach(function (o) {
          o.setAttribute('aria-pressed', String(+o.dataset.o === a[qi]));
        });
        recompute();
      }
      if (e.target.closest('#qReset')) {
        a = [null, null, null];
        $$('.quiz__o').forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
        recompute();
      }
    });
    recompute();
  }

  /* ---- quick add from any product card ----------------------------------- */
  D.addEventListener('click', function (e) {
    var b = e.target.closest('[data-variant-id]');
    if (!b) return;
    e.preventDefault();
    var label = b.textContent;
    b.disabled = true;
    PM.addToCart(+b.dataset.variantId, +(b.dataset.qty || 1)).then(function () {
      b.textContent = 'Added';
      setTimeout(function () { b.textContent = label; b.disabled = false; }, 1300);
    }).catch(function () { b.textContent = label; b.disabled = false; });
  });


  /* ---- PDP: variants, packs, quantity ------------------------------------ */
  var vjson = $('#pdpVariants');
  if (vjson) {
    var variants = JSON.parse(vjson.textContent);
    var chosen = [];
    $$('[data-opt]').forEach(function (b) {
      if (b.getAttribute('aria-pressed') === 'true') chosen[+b.dataset.opt] = b.dataset.val;
    });
    var qty = 1, pack = 1;

    function currentVariant() {
      return variants.filter(function (v) {
        return chosen.every(function (val, i) { return val == null || v.options[i] === val; });
      })[0];
    }
    function paint() {
      var v = currentVariant();
      if (!v) return;
      $('#variantId').value = v.id;
      $('#price').textContent = money(v.price);
      var mrp = $('#mrp'), save = $('#saveLine');
      if (mrp) mrp.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : '';
      if (save) save.textContent = v.compare_at_price > v.price ? 'Save ' + money(v.compare_at_price - v.price) : '';

      var stock = $('#stockLine');
      if (stock) {
        stock.textContent = !v.available ? 'Out of stock'
          : (v.inventory_quantity > 0 ? v.inventory_quantity + ' cans in stock' : 'In stock');
      }
      /* only repaint the can caption when the variant is a real option. On a
         single-variant product v.title is the literal string "Default Title",
         which was rendering as "Default Title a pouch" on the live PDP. */
      var canMg = $('#canMg');
      if (canMg && v.title && v.title !== 'Default Title') canMg.textContent = v.title;

      var total = qty * pack;
      $('#qtyInput').value = total;
      $('#qtyOut').textContent = qty;
      /* every tier row shows its own live total for the selected variant */
      $$('[data-tier-price]').forEach(function (el) {
        el.textContent = money(v.price * (parseInt(el.dataset.tierPrice, 10) || 1));
      });
      var atc = $('#atc'), tot = $('#atcTotal');
      if (atc) atc.disabled = !v.available;
      if (tot) tot.textContent = money(v.price * total);
      if (atc && !v.available) atc.textContent = 'Sold out';

      var mp = $('.mbar__info b'), mb = $('.mbar [data-variant-id]');
      if (mp) mp.textContent = money(v.price * total);
      if (mb) { mb.dataset.variantId = v.id; mb.dataset.qty = total; }
    }

    D.addEventListener('click', function (e) {
      var t;
      if ((t = e.target.closest('[data-opt]'))) {
        var i = +t.dataset.opt;
        chosen[i] = t.dataset.val;
        $$('[data-opt="' + i + '"]').forEach(function (b) {
          b.setAttribute('aria-pressed', String(b === t));
        });
        return paint();
      }
      if ((t = e.target.closest('[data-pack]'))) {
        pack = +t.dataset.pack;
        $$('[data-pack]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === t)); });
        return paint();
      }
      /* not the mobile bar's Add button: pouchman-pdp.js parks the tower count on it as
         data-qty, and matching it here re-ran paint() with qty + n and an undiscounted total,
         so the button and the bar drifted from the tower after one tap */
      if ((t = e.target.closest('[data-qty]:not([data-variant-id])'))) {
        qty = Math.max(1, Math.min(9, qty + (+t.dataset.qty)));
        return paint();
      }
      if ((t = e.target.closest('[data-media]'))) {
        $$('[data-media]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === t)); });
      }
    });

    /* A DATE, not a duration. The server already computed the default eta and
       parked it on the element; the pincode only shifts it. "Arrives Tue 12
       Aug" outperforms "2 to 4 days" everywhere, and a bare duration makes the
       buyer do arithmetic at the exact moment they are deciding. */
    var pinForm = $('#pinForm');
    if (pinForm) pinForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var out = $('#pinResult');
      var val = $('#pin').value.replace(/\D/g, '');
      if (val.length !== 6) { out.textContent = 'Enter a six digit pincode.'; return; }
      /* metro pincodes are a day quicker; everything else takes the default */
      var metro = /^(11|40|56|60|70|50|38|41|44|20)/.test(val);
      var days = metro ? 1 : 3;
      var d = new Date();
      d.setDate(d.getDate() + days);
      var eta = d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
      out.textContent = 'Ordered today, ' + val + ' gets it about ' + eta + '.';
    });

    /* the strength explainer */
    var scale = $('#scaleModal');
    if (scale) {
      var openScale = function () { scale.hidden = false; D.body.style.overflow = 'hidden'; };
      var closeScale = function () { scale.hidden = true; D.body.style.overflow = ''; };
      D.addEventListener('click', function (e) {
        if (e.target.closest('[data-scale-open]')) return openScale();
        if (e.target.closest('[data-scale-close]') || e.target === scale) return closeScale();
      });
      D.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !scale.hidden) closeScale(); });
    }

    paint();

    /* ---- media swap + lightbox -------------------------------------------
       The numbered thumbs used to only toggle their own pressed state; the
       stage image never changed. Media URLs ride in #pdpMedia. */
    var mediaEl = $('#pdpMedia');
    var mediaList = [];
    try { mediaList = JSON.parse(mediaEl ? mediaEl.textContent : '[]') || []; } catch (e) {}
    var mIdx = 0;
    function showMedia(i) {
      if (!mediaList.length) return;
      mIdx = (i + mediaList.length) % mediaList.length;
      var img = $('#pdpImg');
      if (img) { img.removeAttribute('srcset'); img.src = mediaList[mIdx]; }
      $$('[data-media]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(+b.dataset.media === mIdx));
      });
      var lb = $('#lbImg'), lc = $('#lbCount');
      if (lb && !$('#lightbox').hidden) lb.src = mediaList[mIdx];
      if (lc) lc.textContent = (mIdx + 1) + ' of ' + mediaList.length;
    }
    D.addEventListener('click', function (e) {
      var t = e.target.closest('[data-media]');
      if (t) showMedia(+t.dataset.media);
    });

    var lb = $('#lightbox');
    if (lb) {
      var openLb = function () {
        $('#lbImg').src = mediaList[mIdx] || ($('#pdpImg') && $('#pdpImg').src) || '';
        var lc = $('#lbCount');
        if (lc) lc.textContent = (mIdx + 1) + ' of ' + mediaList.length;
        lb.hidden = false; D.body.style.overflow = 'hidden';
      };
      var closeLb = function () { lb.hidden = true; D.body.style.overflow = ''; };
      D.addEventListener('click', function (e) {
        if (e.target.closest('[data-lightbox-open]') || e.target.id === 'pdpImg') return openLb();
        if (e.target.closest('[data-lightbox-close]') || e.target === lb) return closeLb();
        if (e.target.closest('[data-lightbox-prev]')) return showMedia(mIdx - 1);
        if (e.target.closest('[data-lightbox-next]')) return showMedia(mIdx + 1);
      });
      D.addEventListener('keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'Escape') closeLb();
        else if (e.key === 'ArrowLeft') showMedia(mIdx - 1);
        else if (e.key === 'ArrowRight') showMedia(mIdx + 1);
      });
    }

    /* ---- stage tint ------------------------------------------------------
       Same sampling as the brand tiles: the stage takes the can's own colour,
       washed pale, so every product's page is quietly its own. */
    (function stageTint() {
      var stage = $('[data-tint-scope]');
      var img = $('#pdpImg');
      if (!stage || !img) return;
      function go() {
        try {
          var c = D.createElement('canvas'), n = 24;
          c.width = c.height = n;
          var x = c.getContext('2d', { willReadFrequently: true });
          x.drawImage(img, 0, 0, n, n);
          var d = x.getImageData(0, 0, n, n).data;
          /* DOMINANT hue bucket, not the mean. Averaging a whole lid washed
             every CLEW and VELO can to the same lavender (verified: blueberry
             rgb(204,194,218) vs cherry rgb(206,196,221), indistinguishable),
             because a mean of purple, red and white is always mauve. Bucket
             the qualifying pixels by hue and average the LARGEST bucket, so
             blueberry goes violet and cherry goes red. */
          var buckets = [];
          for (var bi = 0; bi < 12; bi++) buckets.push([0, 0, 0, 0]);
          for (var i = 0; i < n * n; i++) {
            if (Math.hypot((i % n) - (n - 1) / 2, ((i / n) | 0) - (n - 1) / 2) > n * 0.34) continue;
            var o = i * 4;
            if (d[o + 3] < 200) continue;
            var R = d[o], G = d[o + 1], B = d[o + 2];
            var mx = Math.max(R, G, B), mn = Math.min(R, G, B);
            if (mx > 238 || mx < 26 || mx - mn < 18) continue;
            var h;
            if (mx === R) h = ((G - B) / (mx - mn) + 6) % 6;
            else if (mx === G) h = (B - R) / (mx - mn) + 2;
            else h = (R - G) / (mx - mn) + 4;
            var bk = buckets[Math.floor(h) * 2 + (h % 1 > 0.5 ? 1 : 0)];
            bk[0] += R; bk[1] += G; bk[2] += B; bk[3]++;
          }
          var best = buckets[0];
          buckets.forEach(function (bk) { if (bk[3] > best[3]) best = bk; });
          if (best[3] < 8) return;
          var r = best[0], g = best[1], b = best[2], hits = best[3];
          var mixTo = function (k) {
            return 'rgb(' + [r, g, b].map(function (vv) {
              return Math.round(255 * k + (vv / hits) * (1 - k));
            }).join(',') + ')';
          };
          stage.style.setProperty('--tint-a', mixTo(0.66));
          stage.style.setProperty('--tint-b', mixTo(0.9));
        } catch (e) { /* tainted canvas, the ice wash stands */ }
      }
      img.crossOrigin = 'anonymous';
      if (img.complete && img.naturalWidth) go();
      else img.addEventListener('load', go);
    })();

    /* ---- recently viewed -------------------------------------------------
       Objection: "I compared three cans and lost the one I liked". Pure
       localStorage, capped at 8, current can excluded from the rail. */
    (function recentlyViewed() {
      var meEl = $('#pdpRv');
      if (!meEl) return;
      var me = {};
      try { me = JSON.parse(meEl.textContent); } catch (e) { return; }
      var KEY = 'pm_rv', list = [];
      try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) {}
      var row = $('[data-rv-row]'), sec = $('[data-rv]');
      if (row && sec) {
        var others = list.filter(function (x) { return x.handle !== me.handle; }).slice(0, 6);
        if (others.length) {
          others.forEach(function (x) {
            var a = D.createElement('a');
            a.href = x.url;
            var img = D.createElement('img');
            img.src = x.img; img.alt = ''; img.loading = 'lazy';
            var b = D.createElement('b'); b.textContent = x.title;
            var sp = D.createElement('span'); sp.textContent = money(x.price);
            a.append(img, b, sp);
            row.appendChild(a);
          });
          sec.hidden = false;
        }
      }
      list = [me].concat(list.filter(function (x) { return x.handle !== me.handle; })).slice(0, 8);
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    })();

    /* ---- the pair, reason led, with a combined total ---------------------
       Built from the live catalogue: predictive search on the brand, keep
       in-stock cans only, pick the nearest DIFFERENT strength, then fetch its
       first variant id so "Add both" is a real one-call cart write. The
       section stays hidden unless a real partner exists, so it can never name
       a can that cannot be bought. */
    (function pair() {
      var sec = $('[data-pair]');
      if (!sec || sec.dataset.available !== 'true') return;
      var brand = sec.dataset.brand, myMg = parseFloat(sec.dataset.mg) || 0, myHandle = sec.dataset.handle;
      var myPrice = parseInt(sec.dataset.price, 10), myVid = sec.dataset.vid;
      fetch('/search/suggest.json?q=' + encodeURIComponent(brand) +
            '&resources%5Btype%5D=product&resources%5Blimit%5D=10' +
            '&resources%5Boptions%5D%5Bunavailable_products%5D=hide')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var items = (d.resources && d.resources.results && d.resources.results.products) || [];
          var best = null, bestGap = 1e9;
          items.forEach(function (it) {
            var h = it.url.split('/products/')[1];
            if (!h || h.split('?')[0] === myHandle) return;
            var m = (it.title.match(/(\d+(?:\.\d+)?)\s*mg/i) || [])[1];
            var gap = m ? Math.abs(parseFloat(m) - myMg) : 999;
            if (gap === 0) gap = 998; /* same strength adds nothing; prefer a step away */
            if (gap < bestGap) { bestGap = gap; best = it; }
          });
          if (!best) return;
          var handle = best.url.split('/products/')[1].split('?')[0];
          return fetch('/products/' + handle + '.js')
            .then(function (r) { return r.json(); })
            .then(function (prod) {
              var pv = prod.variants && prod.variants[0];
              if (!pv || !pv.available) return;
              $('[data-pair-img]', sec).src = best.image || (best.featured_image && best.featured_image.url) || '';
              $('[data-pair-title]', sec).textContent = best.title;
              var m = (best.title.match(/(\d+(?:\.\d+)?)\s*mg/i) || [])[1];
              $('[data-pair-reason]', sec).textContent = m
                ? (parseFloat(m) > myMg ? 'Same brand, one step stronger' : 'Same brand, one step lighter')
                : 'Same brand, different can';
              $('[data-pair-price]', sec).textContent = money(pv.price);
              $('[data-pair-total]', sec).textContent = money(pv.price + myPrice);
              var btn = $('[data-pair-add]', sec);
              btn.addEventListener('click', function () {
                btn.disabled = true;
                fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                  body: JSON.stringify({ items: [{ id: +myVid, quantity: 1 }, { id: pv.id, quantity: 1 }] })
                }).then(function (r) { return r.json(); })
                  .then(function () { PM.refreshCart(); btn.textContent = 'Both in the cart'; })
                  .catch(function () { btn.disabled = false; });
              });
              sec.hidden = false;
            });
        })
        .catch(function () { /* stays hidden */ });
    })();
  }

  /* ---- cart: collapsed "Have a code?" ------------------------------------
     Framework correction #1: an OPEN coupon field sends buyers hunting for
     codes and a share never come back. Collapsed link, cart only. Shopify
     applies codes via /discount/<code>, which sticks to the checkout session. */
  function applyCode(box) {
    var code = $('input', box).value.trim();
    if (code) location.href = '/discount/' + encodeURIComponent(code) + '?redirect=%2Fcheckout';
  }
  /* delegated: the cart section re-renders in place after every change */
  D.addEventListener('click', function (e) {
    var t = e.target.closest('[data-code-toggle]');
    if (t) {
      var box = $('[data-code-form]');
      if (box) { box.hidden = !box.hidden; if (!box.hidden) $('input', box).focus(); }
      return;
    }
    var ap = e.target.closest('[data-code-apply]');
    if (ap) applyCode(ap.closest('[data-code-form]'));
  });
  D.addEventListener('keydown', function (e) {
    /* Enter must not submit the surrounding cart form */
    var box = e.target.closest && e.target.closest('[data-code-form]');
    if (box && e.key === 'Enter') { e.preventDefault(); applyCode(box); }
  });

  /* ---- shop: mobile filter rail ------------------------------------------ */
  D.addEventListener('click', function (e) {
    if (!e.target.closest('#railToggle')) return;
    var rail = $('#railBody'), t = $('#railToggle');
    var open = rail.classList.toggle('is-open');
    t.setAttribute('aria-expanded', String(open));
  });
  var sortSel = $('#sort');
  if (sortSel) sortSel.addEventListener('change', function () { $('#sortForm').submit(); });

  /* ---- cart: line quantity, removal, select mode -------------------------
     Owner, 2026-10-14: removing several lines quickly made items vanish or come back. Root
     cause: every tap fired its own /cart/change.js and then location.reload(). Two writes in
     flight read the same cart and the later one won, and the first reload aborted whatever was
     still in flight, so the page showed a cart nobody asked for.
     Measured 2026-10-14 on this store: line KEYS are not stable. Removing one line moved the can
     tier, the discount allocation of every other can line changed, and Shopify gave those lines
     new keys (54486460891502:2c59... became :baa0...). The next tap still carried the key painted
     before the first write and got 400 "no valid id or line parameter".
     Now every write goes through ONE queue; a line is named by what it is (variant id, plus
     ":gift" for the claimed free box), and its CURRENT key and quantity are looked up in the cart
     Shopify returned for the previous write; several removals go out as a single
     /cart/update.js with a full updates map; the section re-renders in place from
     /cart?section_id= once the queue is empty. */
  (function cartPage() {
    var host = $('[data-cart-root]'); if (!host) return;
    var sid = host.dataset.section, wrap = D.getElementById('shopify-section-' + sid) || host.parentNode;
    var queue = Promise.resolve(), pending = 0, qty = {}, keyOf = {}, fresh = false;
    function root() { return $('[data-cart-root]', wrap); }
    function ident(it) { return it.variant_id + (it.properties && it.properties._free_box ? ':gift' : ''); }
    function readQty() { qty = {}; $$('[data-line]', wrap).forEach(function (r) { qty[r.dataset.key] = +r.dataset.qty; }); fresh = false; }
    function fromCart(c) {
      if (c && c.items) {
        qty = {}; keyOf = {};
        c.items.forEach(function (it) { var id = ident(it); qty[id] = (qty[id] || 0) + it.quantity; if (!keyOf[id]) keyOf[id] = it.key; });
        fresh = true; paintCart(c.item_count);
      }
      return c;
    }
    /* the live cart before the first write of a burst: keys are only good until the next write */
    function live() { return fresh ? Promise.resolve() : fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw new Error('The cart did not load. Try again.'); return r.json(); }).then(fromCart); }
    function post(url, body) {
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (j) {
            if (!r.ok || !j.items) throw new Error(j.description || j.message || 'The cart did not update. Try again.');
            return j;
          });
        });
    }
    function rerender() {
      var note = $('#cartNote', wrap), noteVal = note ? note.value : null;
      return fetch('/cart?section_id=' + encodeURIComponent(sid), { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var next = doc.getElementById('shopify-section-' + sid) || doc.body;
          if (!$('[data-line]', next)) { location.reload(); return; } /* now empty: the empty state carries its own script */
          wrap.innerHTML = next.innerHTML;
          var n2 = $('#cartNote', wrap); if (n2 && noteVal !== null) n2.value = noteVal;
          readQty();
          if (PM.paintLadder) PM.paintLadder();
          if ($('.mbar', wrap)) D.body.classList.add('has-mbar');
          if (window.PMFreeBox && PMFreeBox.check) PMFreeBox.check(false);
        });
    }
    function fail(err) {
      var e = $('[data-cart-err]', wrap);
      return rerender().then(function () { e = $('[data-cart-err]', wrap); if (e) { e.textContent = (err && err.message) || 'The cart did not update. Try again.'; e.hidden = false; } });
    }
    /* job() runs when its turn comes and returns the request to make */
    function enqueue(job) {
      pending++;
      queue = queue.then(live).then(function () { var req = job(); return req ? req.then(fromCart) : null; })
        .catch(function (err) { pending = 0; return fail(err); })
        .then(function () { pending = Math.max(0, pending - 1); if (!pending) return rerender(); });
      return queue;
    }
    readQty();
    PM.cartWrite = enqueue;

    wrap.addEventListener('click', function (e) {
      var r = root(); if (!r) return;
      var step = e.target.closest('[data-line-step]'), rm = e.target.closest('[data-line-remove]');
      if (step || rm) {
        e.preventDefault();
        var row = e.target.closest('[data-line]'), key = row.dataset.key, d = step ? +step.dataset.lineStep : null;
        /* optimistic: show the number the buyer asked for right away */
        var shown = $('[data-line-n]', row), now = +(row.dataset.want || row.dataset.qty);
        var want = rm ? 0 : Math.max(0, now + d);
        row.dataset.want = want; if (shown) shown.textContent = want;
        row.classList.add('is-busy'); if (want === 0) row.classList.add('is-going');
        enqueue(function () {
          var cur = qty[key]; if (cur == null) return null;      /* already gone */
          var target = rm ? 0 : Math.max(0, cur + d);
          if (target === cur) return null;
          return post('/cart/change.js', { id: keyOf[key], quantity: target });
        });
        return;
      }
      if (e.target.closest('[data-sel-on]')) { setSel(true); return; }
      if (e.target.closest('[data-sel-off]')) { setSel(false); return; }
      if (e.target.closest('[data-sel-all]')) {
        var boxes = $$('[data-pick]', wrap), all = boxes.every(function (b) { return b.checked; });
        boxes.forEach(function (b) { b.checked = !all; }); syncSel(); return;
      }
      if (e.target.closest('[data-sel-remove]')) {
        var keys = $$('[data-pick]:checked', wrap).map(function (b) { return b.value; });
        if (!keys.length) return;
        keys.forEach(function (k) { var rw = $('[data-line][data-key="' + CSS.escape(k) + '"]', wrap); if (rw) rw.classList.add('is-busy', 'is-going'); });
        var btn = $('[data-sel-remove]', wrap); btn.disabled = true; btn.textContent = 'Removing…';
        enqueue(function () {
          var updates = {}; keys.forEach(function (k) { if (keyOf[k]) updates[keyOf[k]] = 0; });
          return Object.keys(updates).length ? post('/cart/update.js', { updates: updates }) : null;
        });
        return;
      }
      /* in select mode a tap anywhere on a line ticks it, like a photo grid */
      var line = r.classList.contains('is-selecting') && e.target.closest('[data-line]');
      if (line && !e.target.closest('[data-pick]')) {
        e.preventDefault();
        var cb = $('[data-pick]', line); cb.checked = !cb.checked; syncSel();
      }
    });
    wrap.addEventListener('change', function (e) { if (e.target.matches('[data-pick]')) syncSel(); });
    function setSel(on) {
      var r = root(); r.classList.toggle('is-selecting', on);
      $('[data-sel-on]', wrap).hidden = on; $('[data-sel-tools]', wrap).hidden = !on;
      $('[data-sel-act]', wrap).hidden = !on;
      if (!on) $$('[data-pick]', wrap).forEach(function (b) { b.checked = false; });
      syncSel();
    }
    function syncSel() {
      var picked = $$('[data-pick]:checked', wrap), btn = $('[data-sel-remove]', wrap), n = 0;
      $$('[data-line]', wrap).forEach(function (l) { l.classList.toggle('is-picked', $('[data-pick]', l).checked); });
      picked.forEach(function (b) { n += qty[b.value] || 0; });
      btn.disabled = !picked.length;
      btn.textContent = picked.length ? 'Remove ' + n + (n === 1 ? ' can' : ' cans') : 'Tick what to remove';
      var all = $('[data-sel-all]', wrap), boxes = $$('[data-pick]', wrap);
      if (all) all.textContent = boxes.length && picked.length === boxes.length ? 'Clear all' : 'Select all';
    }
  })();


  /* ---- product rails ------------------------------------------------------
     Fills each rail from a real filtered storefront URL through the Section
     Rendering API, because Liquid caps a collection loop at 50 items and only
     ~1 in 50 of this catalogue is in stock. Server render stays as fallback. */
  function railArrows(rail) {
    var prev = rail.parentNode.querySelector('[data-rail-prev]');
    var next = rail.parentNode.querySelector('[data-rail-next]');
    if (!prev || !next) return;
    function step() { return Math.max(200, rail.clientWidth * 0.8); }
    function sync() {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max;
      var none = max <= 2;
      prev.hidden = none; next.hidden = none;
    }
    prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    rail.addEventListener('scroll', sync, { passive: true });
    addEventListener('resize', sync);
    sync();
  }

  /* Owner-set order for a rail.

     The pinned cards come from the SERVER render, not from the fetch. A section
     rendered through ?section_id= gets the section's DEFAULT schema settings, not the
     ones set on this instance in the template, so the fetched copy knows nothing about
     the pinned list and would not carry those products at all. The template instance
     does render them, correctly ordered, so keep those and let the fetch fill the tail.
     A pinned can that is out of stock never renders, so it drops out on its own. */
  function pinFirst(existing, fetched, pin) {
    var rank = {};
    pin.forEach(function (h, i) { rank[h] = i; });
    var handleOf = function (k) { return (k.getAttribute && k.getAttribute('data-handle')) || ''; };
    var first = existing.filter(function (k) { return rank[handleOf(k)] !== undefined; });
    first.sort(function (a, b) { return rank[handleOf(a)] - rank[handleOf(b)]; });
    var taken = {};
    first.forEach(function (k) { taken[handleOf(k)] = true; });
    var rest = fetched.filter(function (k) { return !taken[handleOf(k)]; });
    return first.concat(rest);
  }

  $$('[data-rail]').forEach(function (rail) {
    railArrows(rail);
    var src = rail.dataset.railSrc;
    if (!src) return;
    var url = src + (src.indexOf('?') > -1 ? '&' : '?') + 'section_id=pouchman-carousel';
    var skel = rail.parentNode.querySelector('[data-rail-skeleton]');
    function reveal() {
      if (skel) skel.remove();
      rail.hidden = false;
      railArrows(rail);
    }
    fetch(url, { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-rail]');
        if (!fresh || !fresh.children.length) return;
        var limit = +(rail.dataset.railLimit || 12);
        var kids = Array.prototype.slice.call(fresh.children);
        /* An owner-set order comes first, in the order it was written; whatever the
           collection returns fills in behind it. A pinned can that has gone out of
           stock simply is not in the response, so it drops out on its own. */
        var pin = (rail.dataset.railPin || '').split(',').map(function (h) { return h.trim(); }).filter(Boolean);
        if (pin.length) kids = pinFirst(Array.prototype.slice.call(rail.children), kids, pin);
        kids = kids.slice(0, limit);
        if (!kids.length) return;
        rail.innerHTML = '';
        kids.forEach(function (k) { rail.appendChild(k); });
      })
      .catch(function () { /* server rendered fallback stays */ })
      .then(reveal);
  });


  /* ---- floating bucks -----------------------------------------------------
     Each buck is the mascot head's cylinder with a product lid on its face.
     The wall is assembled here rather than in Liquid because 32 segments x 3
     bands x 4 tins is 384 elements, which is a lot of markup to ship and
     nothing a crawler or a no-JS reader needs. Without this the lid still
     renders on its own, as a circular product shot. */
  (function bucks() {
    var els = $$('[data-buck]');
    if (!els.length) return;

    function clamp(v){ return Math.max(0, Math.min(255, Math.round(v))); }
    function toRgb(str){
      var m = String(str).trim().match(/^#([0-9a-f]{6})$/i);
      if (m){ var n = parseInt(m[1],16); return [n>>16&255, n>>8&255, n&255]; }
      m = String(str).match(/(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/);
      return m ? [+m[1], +m[2], +m[3]] : [233,233,237];
    }

    /* Per-panel shading. `a` is the panel's bearing around the tin in radians,
       0 facing the camera, wrapped to -PI..PI. Ambient keeps the dark side
       from going black, diffuse gives the barrel falloff, the specular lobe is
       the highlight that reads as plastic, and the rim term lights the two
       silhouette edges so the tin separates from a white page. Without these
       a cylinder of flat fills reads as a printed stripe, which is exactly
       what "still 2d" meant. */
    var KEY = -0.75;
    /* The key light lives in WORLD space, not in the tin's. A panel's local
       bearing plus the tin's yaw is where it actually points once the tin is
       turned, and diffuse and specular have to be evaluated THERE. Evaluating
       them in tin space glues the highlight to the object, so a tin yawed -50
       and one yawed +50 come out identically shaded and both read as stickers.
       The rim term stays in tin space, because a silhouette is a property of
       the view, not of the light. */
    function shadeAt(base, a, scale, yaw) {
      var w = a + (yaw || 0);
      var d = ((w - KEY + Math.PI) % (2 * Math.PI) + 2 * Math.PI) % (2 * Math.PI) - Math.PI;
      var diff = Math.max(0, Math.cos(d));
      var spec = Math.exp(-Math.pow(d / 0.42, 2)) * 0.85;
      var rim = Math.exp(-Math.pow((Math.abs(a) - Math.PI / 2) / 0.30, 2)) * 0.35;
      /* Hard light, deliberately. At ambient .30 the away-facing panels stay
         near the body value, all three rings read as one pale blob on a white
         page, and the tin looks flat however far it is yawed. */
      var k = (0.17 + 0.84 * diff) * (scale || 1);
      return 'rgb(' + base.map(function (v) {
        return clamp(v * k + 255 * spec * 0.5 + 255 * rim * 0.4);
      }).join(',') + ')';
    }

    /* One flat colour per panel is what makes the wall look faceted, like a
       tyre: 40 panels give 40 discrete brightness steps and the eye reads the
       steps, not the curve. The SILHOUETTE was never the problem, at 40 sides
       a 196px tin deviates from a true circle by 0.15px. So each panel instead
       graduates from the shade at its own left edge to the shade at its right
       edge. Neighbours share an edge bearing, so the colours meet exactly and
       the banding disappears with no extra elements. */
    function wall(base, a, half, scale, yaw) {
      return 'linear-gradient(90deg,' +
        shadeAt(base, a - half, scale, yaw) + ' 0%,' +
        shadeAt(base, a, scale, yaw) + ' 50%,' +
        shadeAt(base, a + half, scale, yaw) + ' 100%)';
    }

    /* Tint the tin BODY toward the lid, lightly. Real tins are white or
       silver bodied with only the lid printed, which is what the client's
       reference photography shows, so the sample is a hint of brand rather
       than the wall colour. Sampling ignores the near-white rim, the near
       black print and anything unsaturated, or the tin ends up wearing the
       plate it was shot on. Never throws: a canvas tainted by a CDN with no
       CORS headers raises on getImageData. */
    function tint(img, buck) {
      if (buck.style.getPropertyValue('--body')) return;
      var c = D.createElement('canvas'), n = 24;
      c.width = c.height = n;
      try {
        var x = c.getContext('2d', { willReadFrequently: true });
        x.drawImage(img, 0, 0, n, n);
        var d = x.getImageData(0, 0, n, n).data;
        var r = 0, g = 0, b = 0, hits = 0;
        for (var i = 0; i < n * n; i++) {
          if (Math.hypot((i % n) - (n - 1) / 2, ((i / n) | 0) - (n - 1) / 2) > n * 0.34) continue;
          var o = i * 4;
          if (d[o + 3] < 200) continue;
          var mx = Math.max(d[o], d[o + 1], d[o + 2]), mn = Math.min(d[o], d[o + 1], d[o + 2]);
          if (mx > 238 || mx < 26 || mx - mn < 12) continue;
          r += d[o]; g += d[o + 1]; b += d[o + 2]; hits++;
        }
        if (hits < 12) return;
        var lit = [207, 207, 215], mix = 0.14;
        buck.style.setProperty('--body', 'rgb(' + [r, g, b].map(function (v, j) {
          return clamp(lit[j] * (1 - mix) + (v / hits) * mix);
        }).join(',') + ')');
        paint(buck);
      } catch (e) { /* tainted canvas, the default body stands */ }
    }

    function paint(buck) {
      var cs = getComputedStyle(buck);
      var body = toRgb(cs.getPropertyValue('--body') || '#CFCFD7');
      var lip = toRgb(cs.getPropertyValue('--lipc') || '#EDEDF1');
      var yaw = (parseFloat(cs.getPropertyValue('--yaw')) || 0) * Math.PI / 180;
      $$('.buck__cyl b', buck).forEach(function (el) {
        var i = +el.style.getPropertyValue('--i');
        var seg = +el.getAttribute('data-seg');
        var half = Math.PI / seg;
        var a = ((i / seg) * Math.PI * 2 + Math.PI) % (Math.PI * 2) - Math.PI;
        if (el.className === 'bk-lip') el.style.background = wall(lip, a, half, 1, yaw);
        else if (el.className === 'bk-foot') el.style.background = wall(body, a, half, 0.82, yaw);
        else el.style.background = wall(body, a, half, 1, yaw);
      });
    }

    els.forEach(function (buck) {
      var seg = parseInt(getComputedStyle(buck).getPropertyValue('--seg'), 10) || 40;
      /* tan(180/seg) is the exact panel width for a closed ring; 1.08 overlaps
         neighbours so no hairline seam shows between them. At 3% overlap the
         antialiased edges coincide and seams show through the band. */
      buck.style.setProperty('--segw', (Math.tan(Math.PI / seg) * 1.08).toFixed(5));

      var cyl = D.createElement('div');
      cyl.className = 'buck__cyl';
      ['bk-lip', 'bk-body', 'bk-foot'].forEach(function (cls) {
        for (var i = 0; i < seg; i++) {
          var b = D.createElement('b');
          b.className = cls;
          b.style.setProperty('--i', i);
          b.setAttribute('data-seg', seg);
          cyl.appendChild(b);
        }
      });
      var far = D.createElement('div'); far.className = 'bk-cap bk-far';
      var near = D.createElement('div'); near.className = 'bk-cap bk-near';
      /* order matters: far cap, wall, near cap, then the lid on top, or the
         lid renders behind its own tin */
      buck.insertBefore(near, buck.firstChild);
      buck.insertBefore(cyl, near);
      buck.insertBefore(far, cyl);
      paint(buck);

      var img = buck.querySelector('img');
      if (!img) return;
      img.crossOrigin = 'anonymous';
      if (img.complete && img.naturalWidth) tint(img, buck);
      else img.addEventListener('load', function () { tint(img, buck); });
    });

    /* The tins float on the pm-bob keyframes alone. There used to be a
       depth-weighted mouse parallax layered on top; the owner read the
       constant pointer-chasing as lag, and dropping it also removes a
       document-level mousemove listener. */
  })();


  /* ---- tile grounds ------------------------------------------------------
     Each brand tile takes a gradient lifted from its OWN can, so the row reads
     as fifteen products rather than fifteen identical cards. Sampled on a
     canvas, the same way the hero bucks take their body colour. Degrades to
     the paper wash in the stylesheet if the canvas is blocked. */
  (function tileGrounds() {
    var tiles = $$('.find__brands .sb-tile');
    if (!tiles.length) return;

    function sample(img) {
      var c = D.createElement('canvas'), n = 28;
      c.width = c.height = n;
      var x = c.getContext('2d', { willReadFrequently: true });
      x.drawImage(img, 0, 0, n, n);
      var d = x.getImageData(0, 0, n, n).data;
      var best = null, r = 0, g = 0, b = 0, hits = 0;
      for (var i = 0; i < n * n; i++) {
        /* stay inside the tin: the corners are the supplier's white plate */
        if (Math.hypot((i % n) - (n - 1) / 2, ((i / n) | 0) - (n - 1) / 2) > n * 0.36) continue;
        var o = i * 4;
        if (d[o + 3] < 200) continue;
        var mx = Math.max(d[o], d[o + 1], d[o + 2]), mn = Math.min(d[o], d[o + 1], d[o + 2]);
        /* skip the white collar, the black print and anything grey, or every
           tile samples to the same off-white and the row looks untinted */
        if (mx > 240 || mx < 24 || mx - mn < 18) continue;
        r += d[o]; g += d[o + 1]; b += d[o + 2]; hits++;
      }
      if (hits < 10) return null;
      return [r / hits, g / hits, b / hits];
    }

    /* Mix toward white by `k`. The label is ink on this ground, so the tint
       has to stay pale: at k .78 the darkest sample still leaves the text
       above 9:1. */
    function wash(rgb, k) {
      return 'rgb(' + rgb.map(function (v) {
        return Math.round(255 * k + v * (1 - k));
      }).join(',') + ')';
    }

    tiles.forEach(function (tile) {
      var img = tile.querySelector('.sb-tile__shot');
      if (!img) return;
      function go() {
        try {
          var c = sample(img);
          if (!c) return;
          tile.style.setProperty('--tint-a', wash(c, 0.62));
          tile.style.setProperty('--tint-b', wash(c, 0.86));
        } catch (e) { /* tainted canvas, the stylesheet fallback stands */ }
      }
      img.crossOrigin = 'anonymous';
      if (img.complete && img.naturalWidth) go();
      else img.addEventListener('load', go);
    });
  })();


  /* ---- brand finder -------------------------------------------------------
     Ported from the Zelix fitment pattern. A JSON island holds each brand's
     real strengths and flavours, so picking a brand narrows the other two
     selects to what that brand actually stocks. The button builds one real
     /search URL: the brand as a plain term (brand TAGS are incomplete on this
     catalogue, titles are not) and strength/flavour as `tag:` terms, which
     match exactly. See the section comment for the measurements. */
  $$('[data-find]').forEach(function (box) {
    var form = box.querySelector('[data-find-form]');
    var bSel = box.querySelector('[data-find-brand]');
    var mSel = box.querySelector('[data-find-mg]');
    var fSel = box.querySelector('[data-find-flav]');
    var stock = box.querySelector('[data-find-stock]');
    var qIn = box.querySelector('[data-find-q]');
    var out = box.querySelector('[data-find-count]');
    var island = box.querySelector('[data-find-data]');
    if (!form || !bSel || !mSel || !fSel) return;

    var DATA = [];
    try { DATA = JSON.parse(island.textContent) || []; } catch (e) { DATA = []; }

    function clean(list) {
      return (list || []).map(function (s) { return String(s).trim(); }).filter(Boolean);
    }
    function mgNum(s) { var n = parseFloat(s); return isNaN(n) ? 1e9 : n; }
    function title(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

    /* the union across every brand, for the "All brands" state */
    function pool(key) {
      var seen = {}, all = [];
      DATA.forEach(function (b) {
        clean(b[key]).forEach(function (v) { if (!seen[v]) { seen[v] = 1; all.push(v); } });
      });
      return all;
    }

    function fill(sel, values, placeholder, label) {
      var keep = sel.value;
      sel.innerHTML = '';
      var first = D.createElement('option');
      first.value = '';
      first.textContent = placeholder;
      sel.appendChild(first);
      values.forEach(function (v) {
        var o = D.createElement('option');
        o.value = v;
        o.textContent = label ? label(v) : v;
        sel.appendChild(o);
      });
      /* a value that survives the narrowing stays selected */
      sel.value = values.indexOf(keep) > -1 ? keep : '';
    }

    function narrow() {
      var brand = bSel.value.trim();
      var rec = null;
      for (var i = 0; i < DATA.length; i++) { if (DATA[i].n === brand) { rec = DATA[i]; break; } }
      var mgs = clean(rec ? rec.mg : pool('mg')).sort(function (a, b) { return mgNum(a) - mgNum(b); });
      var fls = clean(rec ? rec.f : pool('f'));
      fill(mSel, mgs, 'Any strength');
      fill(fSel, fls, 'Any flavour', title);
      describe();
    }

    /* no running commentary under the filters: the tiles already carry the
       counts, and the control should read as a control */
    function describe() { if (out) out.textContent = ''; }

    /* Build the query the same way for submit and for the no-JS fallback:
       brand as a term, the other two as tag: terms. */
    function buildQuery() {
      var parts = [];
      var typed = qIn ? qIn.value.trim() : '';
      if (typed) parts.push(typed);
      if (bSel.value.trim()) parts.push(bSel.value.trim());
      if (fSel.value.trim()) parts.push('tag:' + fSel.value.trim());
      if (mSel.value.trim()) parts.push('tag:' + mSel.value.trim());
      return parts.join(' ');
    }

    bSel.addEventListener('change', narrow);
    mSel.addEventListener('change', describe);
    fSel.addEventListener('change', describe);

    /* Build the URL for a given set of terms. */
    function urlFor(parts, wantStock) {
      var u = '/search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(parts.join(' '));
      if (wantStock) u += '&filter.v.availability=1';
      return u;
    }
    /* Ask the catalogue whether a combination exists BEFORE sending anyone to
       it. suggest.json is the cheapest count available and it honours the same
       matching /search does. */
    function countFor(parts, wantStock) {
      var q = parts.join(' ');
      if (!q) return Promise.resolve(1);
      var u = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources%5Btype%5D=product&resources%5Blimit%5D=4' +
        (wantStock ? '&resources%5Boptions%5D%5Bunavailable_products%5D=hide' : '');
      return fetch(u, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var items = (d.resources && d.resources.results && d.resources.results.products) || [];
          return items.length;
        })
        .catch(function () { return 1; }); /* on failure, do not block the buyer */
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var typed = qIn ? qIn.value.trim() : '';
      var brand = bSel.value.trim();
      var flav = fSel.value.trim();
      var mgv = mSel.value.trim();
      var wantStock = !!(stock && stock.checked);

      var base = [];
      if (typed) base.push(typed);
      if (brand) base.push(brand);

      if (!base.length && !flav && !mgv) {
        location.href = '/collections/all' + (wantStock ? '?filter.v.availability=1' : '');
        return;
      }

      /* The finder used to send every buyer straight at the fully constrained
         query. Only CLEW ever had stock for one, so 14 of the 15 brands landed
         on "0 results": the strength and flavour lists are a per-brand UNION
         and were never intersected, and 11 brands have zero in-stock cans while
         the labels advertised their whole catalogue.

         So: try the exact thing asked for, then relax by one constraint at a
         time, and go to the first combination that actually exists. Strength
         goes before flavour because a buyer will accept a different mg of the
         flavour they came for far sooner than the reverse. Dropping "in stock"
         is the LAST resort and is announced, never silent. */
      var full = base.concat(flav ? ['tag:' + flav] : [], mgv ? ['tag:' + mgv] : []);
      var ladder = [{ p: full, s: wantStock, note: '' }];
      if (mgv) ladder.push({ p: base.concat(flav ? ['tag:' + flav] : []), s: wantStock,
        note: 'No ' + mgv + ' in that combination, showing the rest.' });
      if (flav) ladder.push({ p: base.concat(mgv ? ['tag:' + mgv] : []), s: wantStock,
        note: 'No ' + flav + ' in that combination, showing the rest.' });
      if (base.length) ladder.push({ p: base, s: wantStock, note: 'Showing everything from that pick.' });
      if (wantStock) ladder.push({ p: full, s: false, note: 'Nothing in stock for that, showing sold out too.' });
      if (wantStock && base.length) ladder.push({ p: base, s: false, note: 'Nothing in stock for that, showing sold out too.' });

      var go = form.querySelector('[data-find-go]');
      var label = go ? go.textContent : '';
      if (go) { go.disabled = true; go.textContent = 'Checking'; }

      (function step(i) {
        if (i >= ladder.length) {
          location.href = urlFor(full, wantStock);
          return;
        }
        var rung = ladder[i];
        countFor(rung.p, rung.s).then(function (n) {
          if (n > 0) {
            var u = urlFor(rung.p, rung.s);
            if (rung.note) u += '&pm_note=' + encodeURIComponent(rung.note);
            location.href = u;
          } else {
            step(i + 1);
          }
        });
      })(0);

      setTimeout(function () { if (go) { go.disabled = false; go.textContent = label; } }, 6000);
    });

    narrow();
  });

  /* ---- search suggestions -------------------------------------------------
     Products only: this store has no collections and an empty query corpus,
     so Zelix's suggestion and collection groups would render blank here.
     Rows are built with DOM nodes, never innerHTML, so a title carrying a
     quote or an angle bracket cannot break out. */
  $$('.find__search').forEach(function (wrap) {
    var input = wrap.querySelector('[data-find-q]');
    var panel = wrap.querySelector('[data-find-sug]');
    var clear = wrap.querySelector('[data-find-clear]');
    if (!input || !panel) return;
    var timer, active = -1;

    function rows() { return $$('a', panel); }
    function hide() {
      panel.hidden = true;
      panel.textContent = '';
      active = -1;
      input.setAttribute('aria-expanded', 'false');
    }
    function mark(i) {
      var r = rows();
      if (!r.length) return;
      active = (i + r.length) % r.length;
      r.forEach(function (el, n) {
        el.setAttribute('aria-selected', n === active ? 'true' : 'false');
        if (n === active) el.scrollIntoView({ block: 'nearest' });
      });
    }

    function row(p) {
      var a = D.createElement('a');
      a.href = p.url;
      a.setAttribute('role', 'option');
      a.setAttribute('aria-selected', 'false');
      var src = p.image || (p.featured_image && p.featured_image.url) || '';
      if (src) {
        var img = D.createElement('img');
        img.src = src; img.alt = ''; img.loading = 'lazy';
        a.appendChild(img);
      }
      var b = D.createElement('b');
      b.textContent = p.title;
      a.appendChild(b);
      var s = D.createElement('span');
      s.textContent = p.available === false ? 'Sold out' : (p.price ? PM.money(Math.round(parseFloat(p.price) * 100)) : '');
      if (p.available === false) s.className = 'is-out';
      a.appendChild(s);
      return a;
    }

    function run(q) {
      /* unavailable_products=last keeps the 275 sold-out cans below the 43
         buyable ones instead of burying them. */
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources%5Btype%5D=product&resources%5Blimit%5D=8' +
        '&resources%5Boptions%5D%5Bunavailable_products%5D=last';
      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (input.value.trim() !== q) return; /* a slower earlier reply lost */
          var items = (d.resources && d.resources.results && d.resources.results.products) || [];
          panel.textContent = '';
          if (!items.length) {
            var none = D.createElement('p');
            none.className = 'find__none';
            none.textContent = 'No cans match "' + q + '". Try a brand, a flavour or an mg.';
            panel.appendChild(none);
          } else {
            items.forEach(function (p) { panel.appendChild(row(p)); });
          }
          panel.hidden = false;
          active = -1;
          input.setAttribute('aria-expanded', 'true');
        })
        .catch(function () { hide(); });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (clear) clear.hidden = !q;
      clearTimeout(timer);
      if (q.length < 2) return hide();
      timer = setTimeout(function () { run(q); }, 180);
    });

    input.addEventListener('keydown', function (e) {
      if (panel.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); mark(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); mark(active - 1); }
      else if (e.key === 'Enter' && active > -1) { e.preventDefault(); rows()[active].click(); }
      else if (e.key === 'Escape') { hide(); }
    });

    if (clear) {
      clear.hidden = !input.value.trim();
      clear.addEventListener('click', function () {
        input.value = ''; clear.hidden = true; hide(); input.focus();
      });
    }

    D.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) hide();
    });
  });

  /* pages carrying a persistent mobile action bar reserve room for it */
  if ($('.mbar')) D.body.classList.add('has-mbar');

  /* ---- scroll reveal + how-to face spy ----------------------------------
     .sr elements fade up once, staggered by --sr-i. The hidden initial state
     lives behind html.pm-js (stamped inline in the layout), so with scripts
     off nothing is ever invisible. Reduced motion collapses to no-op here
     AND in the CSS, belt and braces. */
  (function () {
    var els = $$('.sr');
    if (els.length) {
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
        els.forEach(function (el) { el.classList.add('sr-in', 'sr-done'); });
      } else {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (!e.isIntersecting) return;
            var el = e.target;
            io.unobserve(el);
            el.classList.add('sr-in');
            /* once the reveal has played, drop the slow staggered transition
               so the element's own (faster) transitions apply again */
            var delay = (parseInt(el.style.getPropertyValue('--sr-i'), 10) || 0) * 70 + 500;
            setTimeout(function () { el.classList.add('sr-done'); }, delay);
          });
        }, { rootMargin: '0px 0px -5% 0px', threshold: 0.05 });
        els.forEach(function (el) { io.observe(el); });
      }
    }

    /* The illustration on the sticky panel tracks the step nearest the middle
       of the viewport. A plain observer band skipped steps on a fast flick
       (a card could cross the band between callbacks), so this is a
       rAF-throttled scroll pick instead: every painted frame chooses the
       nearest step, which by construction moves through them in order. The
       listener only exists while the section is near the viewport. */
    var howto = $('[data-howto]');
    if (!howto) return;
    var steps = $$('[data-howto-step]', howto);
    if (!steps.length) return;
    var active = -1, ticking = false;
    function pick() {
      ticking = false;
      var mid = innerHeight / 2, best = 0, bestD = Infinity;
      for (var i = 0; i < steps.length; i++) {
        var r = steps[i].getBoundingClientRect();
        var d = Math.abs(r.top + r.height / 2 - mid);
        if (d < bestD) { bestD = d; best = i; }
      }
      if (best !== active) {
        active = best;
        for (var j = 0; j < steps.length; j++) {
          steps[j].classList.toggle('howto__step--on', j === active);
        }
        howto.setAttribute('data-step', String(active + 1));
      }
    }
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(pick); }
    }
    if ('IntersectionObserver' in window) {
      var gate = new IntersectionObserver(function (es) {
        if (es[0].isIntersecting) {
          addEventListener('scroll', onScroll, { passive: true });
          pick();
        } else {
          removeEventListener('scroll', onScroll);
        }
      }, { rootMargin: '25% 0px' });
      gate.observe(howto);
    } else {
      addEventListener('scroll', onScroll, { passive: true });
      pick();
    }
  })();

  /* The floating tins bob forever, but only need to while the hero is on
     screen — four composited 3D subtrees animating under a scrolled page is
     exactly the kind of background work a mid-range phone feels. */
  (function () {
    var viz = $('.hero__viz');
    if (!viz || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      viz.classList.toggle('hero__viz--asleep', !es[0].isIntersecting);
    }, { rootMargin: '80px 0px' });
    io.observe(viz);
  })();

  /* ---- the can ladder ----------------------------------------------------
     Server renders the true state; this repaints after any cart mutation by
     riding PM.refreshCart, which every cart write already calls. */
  (function () {
    var ladder, nodes, fill, head;
    function find() {
      ladder = $('[data-ladder]');
      if (!ladder) return false;
      nodes = $$('[data-ladder-node]', ladder); fill = $('[data-ladder-fill]', ladder); head = $('[data-ladder-head]', ladder);
      return true;
    }
    if (!find()) return;
    /* the cart re-renders in place; repaint whatever ladder is on the page now */
    PM.paintLadder = function () { if (find()) paint(+ladder.dataset.count || 0); };
    function paint(count) {
      var reached = -1, next = null;
      nodes.forEach(function (n, i) {
        var q = +n.dataset.qty;
        var done = count >= q;
        n.classList.toggle('is-done', done);
        if (done) reached = i;
        if (!done && !next) next = n;
        n.classList.remove('is-next');
      });
      if (next) next.classList.add('is-next');
      var pct = 0;
      if (reached >= 0) {
        pct = reached / (nodes.length - 1);
        if (reached < nodes.length - 1) {
          var a = +nodes[reached].dataset.qty, b = +nodes[reached + 1].dataset.qty;
          pct += ((count - a) / (b - a)) / (nodes.length - 1);
        }
      }
      if (fill) fill.style.width = Math.min(100, pct * 100).toFixed(1) + '%';
      if (head) {
        if (!next) {
          head.textContent = 'Every rung unlocked. The best price we do, delivered free.';
        } else {
          var short = +next.dataset.qty - count;
          head.textContent = short + (short === 1 ? ' more can unlocks ' : ' more cans unlock ') + next.dataset.label + '.';
        }
      }
    }
    paint(+ladder.dataset.count || 0);
    var orig = PM.refreshCart;
    PM.refreshCart = function () {
      return orig().then(function (c) {
        if (c) paint((c.items || []).reduce(function (n, it) { return /^(Bundle|Merch|Mystery)$/.test(it.product_type || '') ? n : n + it.quantity - (it.properties && it.properties._free_box ? 1 : 0); }, 0));
        return c;
      });
    };
  })();

  /* Menu jumps (/#brands, /#flavours, /#strength) from another page: the browser scrolls to the
     anchor before the JS-filled rails above it have grown, so the target ends up hundreds of
     pixels down. Re-aim once the page has settled, unless the visitor has scrolled themselves. */
  (function () {
    var id = location.hash.slice(1);
    if (!/^(brands|flavours|strength)$/.test(id)) return;
    var moved = false;
    ['wheel', 'touchmove', 'keydown'].forEach(function (t) { addEventListener(t, function () { moved = true; }, { once: true, passive: true }); });
    function aim() { var el = D.getElementById(id); if (el && !moved) el.scrollIntoView({ block: 'start' }); }
    addEventListener('load', function () { aim(); setTimeout(aim, 700); setTimeout(aim, 1600); });
  })();

  /* brand grid: in-stock brands first, the rest behind Show more / Show less */
  (function () {
    var more = $('[data-find-more]');
    if (!more) return;
    var grid = $('.find__brands');
    more.addEventListener('click', function () {
      var open = grid.classList.toggle('is-open');
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
      more.textContent = more.getAttribute(open ? 'data-less' : 'data-more');
      if (!open) {
        var top = grid.getBoundingClientRect().top;
        if (top < 0) window.scrollBy({ top: top - 90, behavior: 'smooth' });
      }
    });
  })();

  PM.refreshCart();
})();

/* favourites: hearts on every product card. Signed out they live in this
   browser; signed in they also go to the stash backend and merge on the
   next visit to The Stash. */
(function () {
  var KEY = 'pm_favs', signedIn = document.documentElement.hasAttribute('data-customer');
  function get() { try { return (JSON.parse(localStorage.getItem(KEY) || '[]') || []).map(Number); } catch (e) { return []; } }
  function set(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  function paint() { var f = get(); document.querySelectorAll('[data-fav]').forEach(function (b) { b.setAttribute('aria-pressed', f.indexOf(+b.getAttribute('data-fav')) > -1 ? 'true' : 'false'); }); }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-fav]'); if (!b) return; e.preventDefault(); e.stopPropagation();
    var id = +b.getAttribute('data-fav'), f = get(), on = f.indexOf(id) === -1;
    f = on ? f.concat([id]) : f.filter(function (x) { return x !== id; }); set(f); paint();
    if (signedIn) fetch('/apps/stash/favourites', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ productId: id, on: on }) }).catch(function () {});
    document.dispatchEvent(new CustomEvent('pm:favs'));
  }, true);
  paint(); window.PMFavs = { get: get, set: set, paint: paint };
})();
